import * as State from 'components/desktop/Accessory/Search/SearchState';
import { useHandler } from 'hooks/useHandler';

export default function useSearchState(initialSearch: State.Type) {
	const [state, rf] = useHandler<State.Type>(initialSearch);
	return {
		state: state,
		handlers: {
			setSearchTerm: rf.createReducer(State.setSearchTerm),
			toggleShowAdvancedSearch: rf.createNoArgReducer(State.toggleShowAdvancedSearch),
		},
	};
}
